<script setup lang="ts">
import '~/styles/_global.scss'
import type { NuxtError } from '#app'
import { useModal } from '~/composables/components/modal'

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})

// fatal な showError→error.vue 描画は path 変化を伴わず reset-modal-lock plugin の
// afterEach が発火しないため、モーダルを開いたまま落ちると isOpen/body.modal-open が残置する。
// error.vue 着地時に明示的に解除する。
useModal().close()

const generic = resolveComponent('CommonsErrorGeneric')
const base = resolveComponent('CommonsErrorBase')
const error404 = resolveComponent('CommonsError404')

let display = base
switch (props.error.statusCode) {
  case 401:
    useAuth().clear()
    clearError({
      redirect: `/sign-in/?redirect_url=${encodeURIComponent(useRoute().fullPath)}`,
    })
    break
  case 404:
    display = error404
    break
  case 408:
  case 409:
  case 118:
    display = generic
    break
}
</script>

<template>
  <div>
    <CommonsHeader />
    <component :is="display" :error="error" />
  </div>
</template>
